export default "__VITE_ASSET__CURSgkTq__"